export default __webpack_public_path__ + "static/media/ForgetPassword.3d448bf3.png";